export const MANDATORY_FIELD = 'Campo obrigatório.';
